module.exports = __webpack_public_path__ + "img/screenshot_new104.be8105a0.png";